// extracted by mini-css-extract-plugin
export var carousel = "slideshow-module--carousel--33cc0";
export var nav = "slideshow-module--nav--4b7e5";
export var root = "slideshow-module--root--41ddf";
export var slide = "slideshow-module--slide--d3e59";